import React from 'react';

export const StatCard = ({ title, value, subtitle, change, icon: Icon }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between">
      <div className="flex-1">
        <p className="text-sm text-gray-600 mb-2">{title}</p>
        <h3 className="text-3xl font-semibold text-gray-900 mb-2">{value}</h3>
        {subtitle && <p className="text-sm text-gray-500 mb-1">{subtitle}</p>}
        {change && <p className="text-sm text-green-600 font-medium">{change}</p>}
      </div>
      <div className="ml-4">
        <Icon className="w-12 h-10 text-gray-300" strokeWidth={1.5} />
      </div>
    </div>
  </div>
);